import React from 'react'
import { FilterAccordion, Checkbox } from '..'
import { Icon } from 'components/atoms'
import * as Styled from './FilterModal.styles'
import { Overlay } from 'components/molecules'
import Tabs from 'components/atoms/Tabs/Tabs'
import FilterOverlayContent from 'components/molecules/NursingIndicatorFilter/FilterOverlayContent/FilterOverlayContent'
import PropTypes from 'prop-types'
import { useMobileSwitch } from 'hooks'
import featureToggles from 'feature-toggles'

const FilterModal = (props) => {
  const {
    filter = {},
    onChange,
    onCustomClose,
    onCustomApply,
    onCustomModalOpen,
    checked,
  } = props
  const isMobile = useMobileSwitch()
  const [open, setOpen] = React.useState(false)

  const getNumberOfSelectedFilter = (filter) => {
    let numOfSelectedFilter = 0

    filter.options.forEach((option) => {
      if (option.options && option.options.length > 0) {
        option.options.forEach((indicatorOption) => {
          if (indicatorOption.selected) {
            numOfSelectedFilter++
          }
        })
        return
      }

      if (option.selected) {
        numOfSelectedFilter++
      }
    })

    return numOfSelectedFilter
  }

  /**
   * handle tab change
   * @param key
   * @param updatedFilter
   */
  const handleFilterTabUpdate = (key, updatedFilter) => {
    const _updatedFilter = {
      ...filter,
      tabs: filter.tabs.map((tab) => {
        if (tab.key === key) {
          return updatedFilter
        }

        return tab
      }),
    }
    onChange?.(_updatedFilter)
  }

  return (
    <>
      <FilterAccordion
        id={ filter.key }
        title={ filter.label }
        handleOpen={ () => {} }
        checked={ checked }
        open>
        <p>{filter.description}</p>
        {filter.options.map((filter, key) => (
          <Checkbox
            id={ filter.label }
            key={ key }
            name={ filter.label }
            label={ filter.label }
            value='Onlineterminbuchung'
            checked={ filter.selected }
            filterId={ filter.id }
            handleChange={ () => {
              // TODO: what happens when this box is checked}}
            } }>
            {filter.label}
          </Checkbox>
        ))}
        <Styled.Button
          className='with-border'
          text='Erweiterten Filter öffnen'
          icon={ <Icon className='icon-f-new-tab' /> }
          onClick={ () => {
            onCustomModalOpen(true)
            setOpen(true)
          } }
          textFirst
        />
      </FilterAccordion>

      <Overlay
        id='indicator-filter-overlay'
        isActive={ open }
        // close with "X" button
        onToggleActive={ () => {
          onCustomModalOpen(false)
          setOpen(false)
        } }
        title={ filter.label }
        variant='dialog'
        // Auswahl zurücksetzten
        onCustomClose={ () => onCustomClose() }
        onCustomApply={ () => {
          setOpen(false)
          !isMobile && onCustomApply()
        } }
        showClose>
        <Tabs>
          {filter.tabs
            .filter((tab) =>
              tab.key === 'quality_internal'
                ? featureToggles.qualityIndicators
                : true
            )
            .map((tab, key) => (
              <Tabs.Tab
                key={ key }
                label={ `${ tab.label }${
                  getNumberOfSelectedFilter(tab) > 0
                    ? ` (${ getNumberOfSelectedFilter(tab) })`
                    : ''
                }` }>
                <FilterOverlayContent
                  filter={ tab }
                  variant={ tab.key === 'quality_external' ? 'square' : 'circle' }
                  onChange={ (updatedFilter) =>
                    handleFilterTabUpdate(tab.key, updatedFilter)
                  }
                  desc={ tab.desc }
                />
              </Tabs.Tab>
            ))}
        </Tabs>
      </Overlay>
    </>
  )
}

FilterModal.propTypes = {
  filter: PropTypes.shape({
    key: PropTypes.string,
    type: PropTypes.oneOf(['modal']),
    label: PropTypes.string,
    description: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        label: PropTypes.string,
        selected: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
      })
    ),
    tabs: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        label: PropTypes.string,
        description: PropTypes.string,
        selected: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
        options: PropTypes.arrayOf(
          PropTypes.shape({
            key: PropTypes.string,
            label: PropTypes.string,
            type: PropTypes.oneOf(['group']),
            selected: PropTypes.oneOfType([
              PropTypes.bool,
              PropTypes.number,
              PropTypes.string,
            ]),
          })
        ),
      })
    ),
  }),
  /** close handle for dialog **/
  onCustomClose: PropTypes.func,
  /** on apply **/
  onCustomApply: PropTypes.func,
  checked: PropTypes.bool,
}

export default FilterModal
